<div class="st-drawer-wrapper">
  <a href=""></a>
  <div class="st-drawer-header lg-p-x show-border">
    <a *ngIf="authService.loggedUser$.value?.viewMaestros" [href]="equipmetUrl" target="_blank">
      Gestionar maestro de equipos
      <app-st-icon name="open_in_new"></app-st-icon>
    </a>
    <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
  </div>
  <div class="st-drawer-content">
    <div class="flex gap-200">
      <app-st-icon [bigAvatar]="true" [avatar]="true" [bold]="true" [name]="nzData.equipment.equipmentType?.name | equipmentIcon"></app-st-icon>
      <div class="flex flex-column">
        <p class="text-header-24">{{nzData.equipment.equipmentType?.name}}</p>
        <span class="text-label-18 text-dark">{{nzData.equipment.name}}</span>
      </div>
    </div>

    <app-list-key-value [keysWidth]="{value: 160, unit: 'px'}"
                        [innerRowGap]="{value: 24, unit: 'px'}"
                        [innerColumnGap]="{value: 16, unit: 'px'}"
                        [valuesMaxWidth]="{value: 60, unit: '%'}"
                        [data]="setKeyValueData()"></app-list-key-value>

    @if (!!nzData.equipment.documents?.length) {
      <div class="flex flex-column gap-100">
        <h5 class="text-header-18">Documentación</h5>
        @for (doc of nzData.equipment.documents; track doc.id) {
          <app-doc-info-card
            (click)="openDocDrawer(doc)"
            (onActionBtnEvent)="onActionBtn($event, doc)"
            [isActive]="this.docCardsActivate.includes(doc.id)"
            [document]="doc"
            [isCompact]="true"
            [showOptions]="false"
            [showCheckbox]="false"
            [entityId]="nzData.equipment.id"
            [entityType]="'Equipment'"
          ></app-doc-info-card>
        }
      </div>
    }

  </div>
</div>
